export enum GarfieldPivotDisplayUnit {
	dollars = 'dollars',
	thousands = 'thousands',
	millions = 'millions',
	perCapita = 'perCapita',
	perStudent = 'perStudent',
	percentChange = 'percentChange',
	percentOfTotal = 'percentOfTotal'
}

export enum GarfieldPivotDisplayUnitLabel {
	dollars = '$ Dollars',
	thousands = '$K Thousands',
	millions = '$M Millions',
	perCapita = '$ per Capita',
	perStudent = '$ per Student',
	percentChange = '% Change',
	percentOfTotal = '% of Total'
}
